import EventOverviewPage from '@/event/pages/EventOverviewPage.vue';
import EventPage from '@/event/pages/EventPage.vue';
import EventSeriesPage from '@/event/pages/EventSeriesPage.vue';
import EventSeriesLocationTab from '@/event/tabs/series/EventSeriesLocationTab.vue';
import EventSeriesOrganisationTab from '@/event/tabs/series/EventSeriesOrganisationTab.vue';
import { _requireAuth, requireAdmin } from '@/plugins/router';
import { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import EventAllocationsEditPage from './pages/EventAllocationsEditPage.vue';
import EventCreatePage from './pages/EventCreatePage.vue';
import EventSeriesCreatePage from './pages/EventSeriesCreatePage.vue';
import EventAllocationsTab from './tabs/event/EventAllocationsTab.vue';
import EventLinksTab from './tabs/event/EventLinksTab.vue';
import EventMasterDataTab from './tabs/event/EventMasterDataTab.vue';
import EventOrganisationTab from './tabs/event/EventOrganisationTab.vue';
import EventVariantsTab from './tabs/event/EventVariantsTab.vue';
import EventSeriesAppointmentTab from './tabs/series/EventSeriesAppointmentTab.vue';
import EventSeriesDetailsTab from './tabs/series/EventSeriesDetailsTab.vue';
import EventSeriesLinksTab from './tabs/series/EventSeriesLinksTab.vue';
import EventSeriesOverviewTab from './tabs/series/EventSeriesOverviewTab.vue';

// A malformed ID falls through to the 404 page; the GraphQL API would reject it as a query variable. The API returns
// IDs in lower case, so an upper-case one would not match the event's own data.
const UUID_PATTERN = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

export const eventFullscreenRoutes = <RouteRecordRaw[]>[
    {
        path: `/events/:eventId(${UUID_PATTERN})/allocations/edit`,
        name: 'event-allocations-edit',
        sensitive: true,
        beforeEnter: [_requireAuth, requireAdmin],
        component: EventAllocationsEditPage,
        props: true,
    },
];

export const eventRoutes = <RouteRecordRaw[]>[
    {
        path: '/events',
        children: [
            {
                path: '',
                name: 'events',
                component: EventOverviewPage,
            },
            {
                path: 'add',
                name: 'add-event',
                beforeEnter: requireAdmin,
                component: EventCreatePage,
                props: (r: RouteLocationNormalized) => ({
                    seriesId: r.query.seriesId,
                    seriesName: r.query.seriesName,
                }),
            },
            {
                path: ':eventId',
                component: EventPage,
                props: true,
                children: [
                    {
                        path: '',
                        redirect: { name: 'event-masterdata-tab' },
                    },
                    {
                        path: 'master-data',
                        name: 'event-masterdata-tab',
                        component: EventMasterDataTab,
                        props: true,
                    },
                    {
                        path: 'allocations',
                        name: 'event-allocations-tab',
                        component: EventAllocationsTab,
                        props: true,
                    },
                    {
                        path: 'organisation',
                        name: 'event-organisation-tab',
                        component: EventOrganisationTab,
                        props: true,
                    },
                    {
                        path: 'links',
                        name: 'event-links-tab',
                        component: EventLinksTab,
                        props: true,
                    },
                    {
                        path: 'variants',
                        name: 'event-variants-tab',
                        component: EventVariantsTab,
                        props: true,
                    },
                ],
            },
            {
                path: 'series/add',
                name: 'add-event-series',
                beforeEnter: requireAdmin,
                component: EventSeriesCreatePage,
            },
            {
                path: 'series/:seriesId',
                component: EventSeriesPage,
                props: true,
                children: [
                    {
                        path: '',
                        redirect: { name: 'event-series-overview' },
                    },
                    {
                        path: 'overview',
                        name: 'event-series-overview',
                        component: EventSeriesOverviewTab,
                        props: true,
                    },
                    {
                        path: 'details',
                        name: 'event-series-details',
                        component: EventSeriesDetailsTab,
                        props: true,
                    },
                    {
                        path: 'org',
                        name: 'event-series-org',
                        component: EventSeriesOrganisationTab,
                        props: true,
                    },
                    {
                        path: 'appointment',
                        name: 'event-series-appointment',
                        component: EventSeriesAppointmentTab,
                        props: true,
                    },
                    {
                        path: 'location',
                        name: 'event-series-location',
                        component: EventSeriesLocationTab,
                        props: true,
                    },
                    {
                        path: 'links',
                        name: 'event-series-links',
                        component: EventSeriesLinksTab,
                        props: true,
                    },
                ],
            },
        ],
    },
];
